import { EnrolmentNoCommissionReason, EnrolmentNotEnrolledReason } from '@studyportals/sp-lord-business-interface';
import { ReviewReason } from './review-reason';

const NO_COMMISSION_REASON_VALUES = Object.values(EnrolmentNoCommissionReason);
const NOT_ENROLLED_REASON_VALUES = Object.values(EnrolmentNotEnrolledReason);

// Two independent enums by design (D10): why a real enrolment earns no commission and why an
// enrolment never happened are different questions. TUITION_PAYMENT_ISSUE is the one wire value
// both enums happen to share; a plain string-keyed label map handles that overlap for free.
const LABELS_BY_VALUE: Record<string, string> = {
	[EnrolmentNoCommissionReason.AGENT_ASSISTED]: 'Agent Assisted',
	[EnrolmentNoCommissionReason.ATTRIBUTION_CHANNEL_CONFLICT]: 'Attribution/Channel Conflict',
	[EnrolmentNoCommissionReason.PROGRAMME_LEVEL_OUT_OF_SCOPE]: 'Programme/Level Out of Scope',
	[EnrolmentNoCommissionReason.DOMESTIC_STUDENT]: 'Domestic student',
	[EnrolmentNoCommissionReason.FULL_SCHOLARSHIP]: 'Full Scholarship',
	[EnrolmentNoCommissionReason.PARTNER_PATHWAY_STUDENT]: 'Partner/Pathway Student',
	[EnrolmentNoCommissionReason.TUITION_PAYMENT_ISSUE]: 'Tuition Payment Issue',
	[EnrolmentNotEnrolledReason.APPLICATION_WITHDRAWN]: 'Application Withdrawn',
	[EnrolmentNotEnrolledReason.VISA_REFUSAL]: 'Visa Refusal',
	[EnrolmentNotEnrolledReason.SCHOLARSHIP_FINANCIAL_AID_DENIED]: 'Scholarship/Financial Aid Denied',
	[EnrolmentNotEnrolledReason.REASON_NOT_PROVIDED]: 'Reason Not Provided'
};

class ReviewReasonFactory {
	private reviewReasonsByValue = new Map<EnrolmentNoCommissionReason | EnrolmentNotEnrolledReason, ReviewReason>();

	public obtainNoCommissionReasons(): ReviewReason[] {
		return NO_COMMISSION_REASON_VALUES.map((_) => this.obtain(_));
	}

	public obtainNotEnrolledReasons(): ReviewReason[] {
		return NOT_ENROLLED_REASON_VALUES.map((_) => this.obtain(_));
	}

	public obtain(value: EnrolmentNoCommissionReason | EnrolmentNotEnrolledReason): ReviewReason {
		if (!this.reviewReasonsByValue.has(value)) {
			// An unrecognized future value shows the raw code rather than a blank cell.
			this.reviewReasonsByValue.set(value, new ReviewReason(LABELS_BY_VALUE[value] || value, value));
		}

		return this.reviewReasonsByValue.get(value) as ReviewReason;
	}
}

const reviewReasonFactory = new ReviewReasonFactory();
export default reviewReasonFactory;
